import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { PROP_TYPES } from 'constants';

import { setLargeChatSize as setLargeChatSizeAction } from '../../../../../../../../store/actions';
import { behavior as behaviorSelectors } from '../../../../../../../../store/selectors';

import ThemeContext from '../../../../../../ThemeContext';
import './styles.scss';

class _ImgReply extends PureComponent {
    static contextType = ThemeContext;

    render() {
        const {
            params: { images: { dims = {} } = {} },
            largeChatSize,
            setLargeChatSize,
        } = this.props;

        const { conversationWindowHeightLarge, conversationWindowWidthLarge } = this.context;

        const { width, height } = dims;
        // Convert map to object
        const message = this.props.message.toJS();
        const { title, image } = message;
        const customCss =
            this.props.message.get('customCss') && this.props.message.get('customCss').toJS();

        if (customCss && customCss.style === 'class') {
            customCss.css = customCss.css.replace(/^\./, '');
        }

        return (
            <div
                className={
                    customCss && customCss.style === 'class' ? `image ${customCss.css}` : 'image'
                }
                style={{
                    cssText: customCss && customCss.style === 'custom' ? customCss.css : undefined,
                }}
            >
                <b className="rw-image-title">{title}</b>
                <div className="rw-image-details" style={{ width, height }}>
                    <img
                        className={`rw-image-frame ${
                            conversationWindowHeightLarge || conversationWindowWidthLarge
                                ? largeChatSize
                                    ? 'rw-zoomed-in'
                                    : 'rw-zoomed-out'
                                : ''
                        }`}
                        src={image}
                        onClick={
                            conversationWindowHeightLarge || conversationWindowWidthLarge
                                ? () => setLargeChatSize(!largeChatSize)
                                : () => {}
                        }
                    />
                </div>
            </div>
        );
    }
}

_ImgReply.propTypes = {
    message: PROP_TYPES.IMGREPLY,
};

_ImgReply.defaultProps = {
    params: {},
};

const mapStateToProps = (state, ownProps) => {
    return {
        largeChatSize: behaviorSelectors.largeChatSize(state.behavior),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setLargeChatSize: (enabled) => dispatch(setLargeChatSizeAction(enabled)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(_ImgReply);
